module.exports = __webpack_public_path__ + "img/vertical_3_5_6000.31a86bf0.png";